module.exports = __webpack_public_path__ + "static/media/syringe-safe-waste.dff7018a.svg";